import { css } from 'emotion';

export const wrapper = css`
  margin: 0 20px;

  > :first-child {
    margin: 10px 0 40px;
  }

  > span {
    margin-bottom: 10px;
  }
`;

export const select = css`
  width: 50%;
`;

export const input = css`
  > span {
    margin: 40px 0 20px;
  }
`;

const placeholder = css`
  content: "";
  border: none;
  margin: 30px 0 0;
`;

export const placeholderWithoutTextButton = css`
  ${placeholder} margin-bottom: 30px;
`;

export const loading = css`
  margin: 60px auto;
  width: 100%;
`;
